import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import ProjectsSettings from './ProjectsSettings';
import SeasonsSettings from './SeasonsSettings';
import PositionsSettings from './PositionsSettings';
import RefereesSettings from './RefereesSettings';
import StadiaSettings from './StadiaSettings';
import EventTypesSettings from './EventTypesSettings';
import TeamsSettings from './TeamsSettings';
import PlayerAssignments from './PlayerAssignments';
import ChangePassword from './ChangePassword';
import UserManagement from './UserManagement';
import AppSettings from './AppSettings';

const tabs = [
  {
    group: 'League',
    items: [
      { id: 'projects', label: 'Projects', icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
        </svg>
      )},
      { id: 'seasons', label: 'Seasons', icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      )},
      { id: 'teams', label: 'Teams', icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      )},
      { id: 'assignments', label: 'Player Assignments', icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
      )},
    ],
  },
  {
    group: 'Reference Data',
    items: [
      { id: 'positions', label: 'Positions', icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      )},
      { id: 'referees', label: 'Referees', icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      )},
      { id: 'stadia', label: 'Stadia', icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      )},
      { id: 'eventtypes', label: 'Event Types', icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
        </svg>
      )},
    ],
  },
  {
    group: 'System',
    items: [
      { id: 'app', label: 'App API Config', icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      )},
      { id: 'changepassword', label: 'Change Password', icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
        </svg>
      )},
    ],
  },
];

const adminTab = { id: 'users', label: 'User Management', icon: (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
  </svg>
)};

const renderContent = (activeTab, isAdmin) => {
  switch (activeTab) {
    case 'projects': return <ProjectsSettings />;
    case 'seasons': return <SeasonsSettings />;
    case 'teams': return <TeamsSettings />;
    case 'assignments': return <PlayerAssignments />;
    case 'positions': return <PositionsSettings />;
    case 'referees': return <RefereesSettings />;
    case 'stadia': return <StadiaSettings />;
    case 'eventtypes': return <EventTypesSettings />;
    case 'app': return <AppSettings />;
    case 'changepassword': return <ChangePassword />;
    case 'users': return isAdmin ? <UserManagement /> : null;
    default: return <ProjectsSettings />;
  }
};

const Settings = () => {
  const [activeTab, setActiveTab] = useState('projects');
  const { user } = useAuth();

  // F2 fix: login returns roles as strings like "ROLE_ADMIN"
  const isAdmin = user?.roles?.includes('ROLE_ADMIN');

  const allGroups = isAdmin
    ? [...tabs, { group: 'Admin', items: [adminTab] }]
    : tabs;

  return (
    <div className="flex gap-6 min-h-[calc(100vh-3.5rem-3rem)]">
      {/* Vertical tab sidebar */}
      <aside className="w-52 flex-shrink-0">
        <nav className="sticky top-0 space-y-5">
          {allGroups.map((group) => (
            <div key={group.group}>
              <div className="text-xs font-semibold text-slate-400 uppercase tracking-wider px-3 mb-1.5">
                {group.group}
              </div>
              <ul className="space-y-0.5">
                {group.items.map((tab) => (
                  <li key={tab.id}>
                    <button
                      onClick={() => setActiveTab(tab.id)}
                      className={`flex items-center gap-2.5 w-full px-3 py-2 rounded-lg text-sm font-medium transition-all duration-150 text-left ${
                        activeTab === tab.id
                          ? 'bg-blue-50 text-blue-700 border border-blue-100'
                          : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'
                      }`}
                    >
                      <span className={activeTab === tab.id ? 'text-blue-600' : 'text-slate-400'}>
                        {tab.icon}
                      </span>
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </aside>

      {/* Content area */}
      <div className="flex-1 min-w-0">
        {renderContent(activeTab, isAdmin)}
      </div>
    </div>
  );
};

export default Settings;
